import { resource, RequestConfig } from '../helper/resource';

/**
 * [No Auth]根据产品代码查询产品文件路径
 */
export function bjhgListUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultLcBjhgVo> {
  return resource.postNoAuth('/bjhg/list', req, config);
}

/**
 * [No Auth]查询专区-九宫格详情信息
 */
export function cardListUsingPOST(
  req: SectionQueryDto | void,
  config?: RequestConfig
): Promise<ApiResultListFixedInvestmentItem> {
  return resource.postNoAuth('/section/card', req, config);
}

/**
 * [No Auth]查询栏目产品信息
 */
export function columnUsingPOST(
  req: SectionQueryDto | void,
  config?: RequestConfig
): Promise<ApiResultLcProductInfoVo> {
  return resource.postNoAuth('/section/column', req, config);
}

/**
 * [No Auth]根据资讯ID查询资讯详情页信息
 */
export function getPInfosByIdUsingPOST(req: SectionQueryDto | void, config?: RequestConfig): Promise<ApiResultLcInfo> {
  return resource.postNoAuth('/section/getPInfosById', req, config);
}

/**
 * [No Auth]不登陆获取收益率
 */
export function getRateUsingPOST(req: void, config?: RequestConfig): Promise<ApiResultstring> {
  return resource.postNoAuth('/section/getRate', req, config);
}

/**
 * [No Auth]查询资讯详情页信息
 */
export function infoUsingPOST(req: SectionQueryDto | void, config?: RequestConfig): Promise<ApiResultLcInfoVo> {
  return resource.postNoAuth('/section/info', req, config);
}

/**
 *  下单留痕
 */
export function leaveUsingPOST_1(req: BjhgLeaveDto | void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/section/leave', req, config);
}

/**
 * 查询客户是否需要走马灯
 */
export function lightUsingPOST(req: ClientDto | void, config?: RequestConfig): Promise<ApiResultPopupVo> {
  return resource.post('/section/light', req, config);
}

/**
 * [No Auth]查询专区-广告位详情信息
 */
export function maPicUsingPOST(
  req: SectionQueryDto | void,
  config?: RequestConfig
): Promise<ApiResultListAdPicManageParam> {
  return resource.postNoAuth('/section/maPic', req, config);
}

/**
 * permission
 */
export function permissionUsingPOST(
  req: PermissionDto | void,
  config?: RequestConfig
): Promise<ApiResultQualificationVo> {
  return resource.post('/section/permission', req, config);
}

/**
 * permissionInstitute
 */
export function permissionInstituteUsingPOST(
  req: PermissionDto | void,
  config?: RequestConfig
): Promise<ApiResultQualificationVo> {
  return resource.post('/section/permission/institute', req, config);
}

/**
 * [No Auth]查询专区-广告位详情信息
 */
export function picUsingPOST(
  req: SectionQueryDto | void,
  config?: RequestConfig
): Promise<ApiResultListAdPicManageParam> {
  return resource.postNoAuth('/section/pic', req, config);
}

/**
 * 查询客户是否需要弹框
 */
export function popupUsingPOST(req: ClientDto | void, config?: RequestConfig): Promise<ApiResultPopupVo> {
  return resource.post('/section/popup', req, config);
}

/**
 * coupon
 */
export function couponUsingPOST(req: BJDetailInfoParam, config?: RequestConfig): Promise<ApiResultListMapstringobject> {
  return resource.post('/section/purchase/coupon', req, config);
}

/**
 * qualification
 */
export function qualificationUsingPOST(
  req: QualificationDto | void,
  config?: RequestConfig
): Promise<ApiResultQualificationVo> {
  return resource.post('/section/purchase/qualification', req, config);
}

/**
 * qualificationInstitute
 */
export function qualificationInstituteUsingPOST(
  req: QualificationDto | void,
  config?: RequestConfig
): Promise<ApiResultQualificationVo> {
  return resource.post('/section/purchase/qualification/institute', req, config);
}

/**
 * [No Auth]查询栏目配置信息
 */
export function querySectionInfoUsingPOST(
  req: SectionQueryDto | void,
  config?: RequestConfig
): Promise<ApiResultListLcWjSectionConfigVo> {
  return resource.postNoAuth('/section/query', req, config);
}

/**
 * [No Auth]获取报价回购产品详情信息
 */
export function queryBJDetailInfoUsingPOST(
  req: BJDetailInfoParam,
  config?: RequestConfig
): Promise<ApiResultBuyBackInfoDto> {
  return resource.postNoAuth('/section/queryBJDetailInfo', req, config);
}

/**
 * 获取报价回购产品交易详情信息
 */
export function queryBJDetailTradeInfoUsingPOST(
  req: BJDetailTradeParam,
  config?: RequestConfig
): Promise<ApiResultBJTradeVo> {
  return resource.post('/section/queryBJDetailTradeInfo', req, config);
}

/**
 * 不再提醒
 */
export function remindUsingPOST(req: ClientDto | void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/section/remind', req, config);
}

/**
 * 消耗客户优惠券
 */
export function useCouponUsingPOST(req: CouponDto | void, config?: RequestConfig): Promise<ApiResultboolean> {
  return resource.post('/section/useCoupon', req, config);
}
